import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { EventSlot } from "../../../library-js/events/EventSlot";
import { Func } from "../../../library-js/tools/TypeUtilities";
import { InspectorContainer } from "../containers/InspectorContainer";
import { InspectorCreationInfo } from "../InspectorCreationInfo";
import { InspectorReference } from "./InspectorReference";

export abstract class InspectorField<T>
{
  static flag = new ClassFlag( "inspector--field" );
  static readonly opener = new ElementType( "field--opener" );
  static readonly openText = "▾";
  static readonly closeText = "▸";  

  get parent(){ return this._info.parentField };  

  _fieldPath:string;

  get fieldPath()
  {
    if ( this._fieldPath )
    {
      return this._fieldPath;
    }

    let fragments:string[] = [];

    let it:InspectorField<any> = this;

    while ( it )
    {
      let memberName = it.memberName;
      
      fragments.push( memberName );

      it = it.parent;
    }

    fragments.reverse();
    

    this._fieldPath = fragments.join( "/" );
  
    return this._fieldPath; 
  }

  protected _info:InspectorCreationInfo;
  get info(){ return this._info; }
  set info( info:InspectorCreationInfo ){ this._info = info; }

  protected _value:T;
  get value(){ return this._value; }
  set value( t:T ){ this._value = t; this.syncValueToElement();}

  protected _allowNull:boolean = true;
  protected _element:Element;
  get element(){ return this._element; }
  readonly onChange:EventSlot<T> = new EventSlot<T>();

  abstract createElement():void;

  onAddedToContainer()
  {

    ClassFlag.inactive.set( InspectorContainer.containerOpener.query( this.container ) ); 
  }

  syncValueToElement(){}

  _visibilityDependencies:string[] = [];
  _updateVisibility:Func<void>;

  get memberName()
  {
    return this.info.path + "";
  }

  getChildField( name:string )
  {
    return this.info.children.find( f => f.memberName === name );
  }

  get container()
  {
    return InspectorContainer.type.getParent( this.element );
  }
}